import { ReactElement } from "react";
import { useSearchParams } from "react-router";
import { IntegrationConfirmFreeAgent } from "./IntegrationConfirmFreeAgent";
import { IntegrationConfirmQuickbooks } from "./IntegrationConfirmQuickbooks";
import { IntegrationConfirmXero } from "./IntegrationConfirmXero";

export const IntegrationConnectionConfirm = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const integrationType = searchParams.get("type");
  if (!integrationType) throw new Error("Cannot find integration type");

  if (!["Quickbooks", "Xero", "FreeAgent"].includes(integrationType))
    throw new Error("Integration type does not exist.");

  return (
    <>
      {integrationType === "Xero" && <IntegrationConfirmXero />}
      {integrationType === "Quickbooks" && <IntegrationConfirmQuickbooks />}
      {integrationType === "FreeAgent" && <IntegrationConfirmFreeAgent />}
    </>
  );
};
